import React from "react";
import { makeStyles, Box, Typography, Divider } from "@material-ui/core";
import OtpPanel from "../../components/panel/otpPanel";
import { getLang } from "app/feature/constants";
import costIcon from "assets/img/cost.png";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyle = makeStyles((theme) => ({
  card: {
    borderRadius: 12,
    background: "white",
    border: "1px solid #D0D5DD",
    padding: 10,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "column",
    marginTop: "15px",
    width: "30%"
  },
}));

export default function MainPageComponent({ lang, totalSpent, isLoading }) {
  const classes = useStyle();

  return (
    <>
      <Box>
        <Typography variant="h6" color="primary" style={{ fontWeight: "bold", marginBottom: "15px" }}>
          {getLang(lang, "label.OTP_REPORT")}
        </Typography>
        <Divider />
        <Box className={classes.card}>
          <Box style={{ display: "flex", marginBottom: "4px" }}>
            <img src={costIcon} alt="cost" /> &nbsp;
            <Typography variant="body1" style={{ color: "#7f7f7f" }}>
              {getLang(lang, "label.TOTAL_SPENT")}
            </Typography>
          </Box>
          <Box mt={0.5} ml={0.5} display="flex" alignItems="flex-end">
            {isLoading ?
              <Skeleton variant="text" animation="wave" width="100%" height={30} />
              :
              <Typography variant="h6">
                $ {totalSpent}
              </Typography>
            }
          </Box>
        </Box>
        <OtpPanel />
      </Box>
    </>
  );
}
